import { render, staticRenderFns } from "./EmpresaAdicionar.vue?vue&type=template&id=4d221c50&"
import script from "./EmpresaAdicionar.vue?vue&type=script&lang=js&"
export * from "./EmpresaAdicionar.vue?vue&type=script&lang=js&"
import style0 from "./empresa_adicionar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports